import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import ChatWidget from "./ChatWidget";

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FBF8F3]">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <ChatWidget />
    </div>
  );
}
